import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, SectionTitle, Intro } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Use a frame to contain content in a design by combining the{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/colors/design'}
            >
              color
            </Link>
            ,{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/stroke/design'}
            >
              stroke
            </Link>{' '}
            and{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/shadow/design'}
            >
              shadow
            </Link>{' '}
            styles to separate the content into visually distinct groups.
          </p>
        </Intro>
        <SectionTitle>Frame Variants</SectionTitle>
        <p>
          There are three available frame variants: Rectangular with squared
          corners, Rectangulary with rounded corners, and Oval.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr className="showcase-table__darker-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--rectangle"></span>
                  Rectangular Frame
                </div>
              </td>
              <td>Squared Corners</td>
            </tr>
            <tr className="showcase-table__dark-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--rectangle-rounded"></span>
                  Rectangular Frame
                </div>
              </td>
              <td>Rounded Corners</td>
            </tr>
            <tr className="showcase-table__darker-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-frame--oval"></span>
                  Oval Frame
                </div>
              </td>
              <td>None</td>
            </tr>
          </tbody>
        </table>
        <SectionTitle className="l-margin-top--xxxlarge">
          Design Environment
        </SectionTitle>
        <p>
          The boundaries of a frame should be defined by either a stroke or a
          shadow but never both.
        </p>
      </Layout>
    </>
  )
}
